// Translations
import form from '../sections/form/translations/ru'

// Translation: Verification > Landing (Russian)
export default Object.freeze({
	sections: { form }
})
